<ziro-top-nav></ziro-top-nav>

<div class="d-flex cdr-dump-wrapper">
  <div class="container-fluid d-flex flex-column">
    <div class="row flex-grow-1">
      <div class="col-md-8 offset-md-2">
        <ziro-breadcrumbs></ziro-breadcrumbs>
        <div class="card">
          <div class="card-header">{{ 'tkey;cdr_dump.card.title' | translate }}</div>
          <div class="card-body">
            <ziro-text [fieldId]="'startDate'"></ziro-text>
            <ziro-text [fieldId]="'endDate'"></ziro-text>
            <ziro-text [fieldId]="'callRecords'"></ziro-text>
            <ziro-text [fieldId]="'unusedPercentage'"></ziro-text>
          </div>
        </div>
      </div>
    </div>
    <ziro-bottom-nav></ziro-bottom-nav>
  </div>
</div>
